module.exports = {
    OKIBAN_SET_IBAN: 'OKIBAN_SET_IBAN',
    OKIBAN_SET_CCC: 'OKIBAN_SET_CCC',
    OKIBAN_VERIFING: 'OKIBAN_VERIFING',
    OKIBAN_ERROR:'OKIBAN_ERROR',
    OKIBAN_RESET: 'OKIBAN_RESET',
    OKIBAN_INTERNAL_RESET: 'OKIBAN_INTERNAL_RESET',
};